import { render, staticRenderFns } from "./settledList.vue?vue&type=template&id=3bf8c471&scoped=true&"
import script from "./settledList.vue?vue&type=script&lang=js&"
export * from "./settledList.vue?vue&type=script&lang=js&"
import style0 from "./settledList.vue?vue&type=style&index=0&id=3bf8c471&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf8c471",
  null
  
)

export default component.exports